export default __webpack_public_path__ + "static/media/linkedin-icon.06d66d51.svg";